const APP = 'FBQ';

const createAction = module => action => `${APP}/${module}/${action}`;

export default createAction;
